<template>
  <b-container fluid="" class="px-0 pb-5">
    <b-container class="max-width" fluid="">
      <title-back-button
        :title="title"
        :show-breadcrumbs="true"
        :current-page="currentPage"
        :prev-page="prevPage"
        :prev-page-link="prevPageLink"
      />
      <div class="row align-items-center">
        <div :class="[bodyPadding ? 'col-12 col-md-5 offset-md-1' : 'col-12 col-md-6']">
          <p v-html="description" />
        </div>
        <div :class="[bodyPadding ? 'col-12 col-md-5' : 'col-12 col-md-6', 'text-center']">
          <b-img :src="this.serviceImage" fluid />
        </div>
        <div :class="[bodyPadding ? 'col-12 col-md-10 offset-md-1' : 'col-12', 'intro mt-3']">
          <slot />
        </div>
      </div>
    </b-container>
  </b-container>
</template>

<script>
import TitleBackButton from "../molecules/TitleBackButton";

export default {
  name: "ServiceIntro",
  components: { TitleBackButton },
  props: {
    title: String,
    description: String,
    serviceImage: String,
    containerImage: String,
    currentPage: String,
    prevPage: String,
    prevPageLink: Object,
    bodyPadding: Boolean,
  },
};
</script>

<style scoped lang="scss">
.intro {
  min-height: 200px;
}
</style>
